import { useTranslation } from "react-i18next";

export function useFirestoreErrorTranslation() {
    const { t } = useTranslation("handleFirestoreError");

    const errorMap = {
        "cancelled": "cancelled",
        "unknown": "unknown",
        "invalid-argument": "invalid-argument",
        "not-found": "not-found",
        "already-exists": "already-exists",
        "permission-denied": "permission-denied",
        "resource-exhausted": "resource-exhausted",
        "deadline-exceeded": "deadline-exceeded",
        "aborted": "aborted",
        "out-of-range": "out-of-range",
        "unimplemented": "unimplemented",
        "internal": "internal",
        "unavailable": "unavailable",
        "data-loss": "data-loss",
    };

    return (error) => {
        let message;

        if (error?.code) {
            const translationKey = errorMap[error.code];
            message = translationKey ? t(translationKey) : `${t('default')}${error.code}`;
        } 
        else {
            message = t('no-code') + (error?.message ? `: ${error.message}` : "");
        }

        return message;
    };
}

export default useFirestoreErrorTranslation;
